<template>
    <div>
        <svg :viewBox="'0 0 ' + width + ' ' + height" xmlns="http://www.w3.org/2000/svg">
            <Legend v-bind:width="width"
				:height="height"
				:startDate="startDate"
				:bins="bins.length"
				:binWidth="binWidth"
                :binInterval="2"
                :scaleZero="true"
                legendFont="small">
			</Legend>
            <template v-if="horizontalValue">
                <line :fill="style.lineColor"
                    :x1="style.padding" :x2="width - style.padding"
                    :y1="scaleY(horizontalValue)" :y2="scaleY(horizontalValue)"
                    stroke="#1081F1" stroke-dasharray="4 2"
                    ></line>
                <text
                    :y="scaleY(horizontalValue) - 5"
                    :x="20"
                    fill="#1081F1"
                    :style="{fontSize: 12, fontWeight: 'bold'}"
                    >
                    Avg cal. {{ horizontalValue }}
                </text>
            </template>
            
            <g v-for="(bin, index) in bins" :key="index">
                <template v-if="bin">
                    <rect
                        :fill="style.barColor"
                        :width="style.barWidth"
                        :height="scaleHeight(bin.value)"
                        :x="centerScaleX(index + 1) - style.barWidth / 2"
                        :y="scaleY(bin.value)"
                        >
                    </rect>
                    <text 
                        :y="scaleY(bin.value) - 5"
                        :x="centerScaleX(index + 1)"
                        text-anchor="middle">
                        {{ bin.value.toFixed(0) }}
                    </text>
                </template>
            </g>
        </svg>
    </div>
</template>

<script>
import Graph from '.'

export default {
    name: 'energy-graph-2d',
    extends: Graph,

    props: {
        horizontalValue: {
            type: Number
        }
    },

    computed: {
        bins() {
            let bins = []

            for (let dateI = this.startDate.getTime() ; dateI < this.date.getTime() ; dateI += this.binInterval) {
                bins.push(this.data.find((point) => {
                    return dateI <= point.time && point.time <= dateI + this.binInterval
                }))
            }
            return bins
        },
        maxValue() {
            return Math.max.apply(Math, this.bins.map((bin) => bin ? bin.value : 0))
        },
        /**
		 * @function 	displayHeight
		 * @desc 		height of graph bars
		 */
		displayHeight() {
			return this.height - this.style.padding * 2 - 35
		}
    },

    methods: {
        /**
		 * @function 	centerScaleX
		 * @desc 		
		 * @param 		{x} Number
		 */
		centerScaleX(x) {
			return (x + 0.5) * this.width / (this.bins.length + 1)
        },
        /**
		 * @function 	scaleY
		 * @desc 		scaling the points on graph w.r.t the maxValue (taking maxValue as maximum value that a point should take)
		 * @param 		{y} Number
		 */
		scaleY(y) {
            let yScale = (this.maxValue - y) / this.maxValue * this.displayHeight + 2 * this.style.padding - this.style.legendHeight + 5
            if(this.scaleHeight(y) == 5)
                yScale = this.displayHeight + 2 * this.style.padding - this.style.legendHeight
            return yScale
            
        },
        scaleHeight(value) {
            return Math.max(value / this.maxValue * this.displayHeight, 5 )
        },
        
        
    }
}
</script>
